import {useTranslation} from "react-i18next";
import {ReactComponent as Coin} from "../../../asset/icons/three-coin-icon.svg";
import facebook from '../../assets/images/facebook.png';
import instagram from '../../assets/images/instagram.png';
import googlePlus from '../../assets/images/g+.png';
import linkedin from '../../assets/images/linked in.png';
import youtube from '../../assets/images/youtube.png';
import twitter from '../../assets/images/tweeter.png';
import earth from '../../assets/images/earth.png';

function FoodOrderStatusModal({data}) {
  const {t} = useTranslation()
  return (
    <>
      <div>{t("order.msg")}</div>
      <div className='food-order-status-code'>{t("order.number")} : {data?.code}</div>
      <div className='food-order-score'>
        <div className='food-order-score-title'>
          {t('rate.till.now')}
        </div>
        <div className='food-order-score-feedCoin'>
          <Coin/><span>{data?.coin}</span>
        </div>
        <div className='food-order-score-howuse'>
          {t("how.to.use")}
        </div>
      </div>
      <div className='food-order-social-media'>
        <div className='food-order-social-media-title'>
          {t("follow.us")}
        </div>
        <div className='food-order-social-media-icons'>
          <div className="icon"><img src={facebook} alt="facebook"/></div>
          <div className="icon"><img src={twitter} alt="twitter"/></div>
          <div className="icon"><img src={instagram} alt="instagram"/></div>
          <div className="icon"><img src={youtube} alt="youtube"/></div>
          <div className="icon"><img src={googlePlus} alt="googlePlus"/></div>
          <div className="icon"><img src={linkedin} alt="linkedin"/></div>
          <div className="icon"><img src={earth} alt="earth"/></div>
        </div>
      </div>
    </>
  );
}

export default FoodOrderStatusModal;
